module.exports = __webpack_public_path__ + "img/04_02.f2af9112.gif";